import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import querystringify from 'querystringify';
import { loginCallbackRoute, RedirectToLogin } from '@twigeducation/oidc-client-react';
import { userManager } from './userManager';
import RedirectToShortCodeUrl from './RedirectToShortCodeUrl';

const CustomLogoutCallback = () => {
    const [isProcessing, setIsProcessing] = useState(true);

    useEffect(() => {
        const handleLogoutCallback = async () => {
            try {
                await userManager.signoutRedirectCallback();

                const postLogoutRedirect = sessionStorage.getItem('postLogoutRedirect');

                if (postLogoutRedirect) {
                    sessionStorage.removeItem('postLogoutRedirect');
                    window.location.href = postLogoutRedirect;
                } else {
                    window.location.href = '/';
                }
            } catch (error) {
                console.error('Logout callback error:', error);
                const postLogoutRedirect = sessionStorage.getItem('postLogoutRedirect');
                if (postLogoutRedirect) {
                    sessionStorage.removeItem('postLogoutRedirect');
                    window.location.href = postLogoutRedirect;
                } else {
                    window.location.href = '/';
                }
            } finally {
                setIsProcessing(false);
            }
        };

        handleLogoutCallback();
    }, []);

    if (isProcessing) {
        return <div>Logging out...</div>;
    }

    return null;
};

const loginRoute = (
    <Route
        path="/login/:districtId?"
        key="login"
        component={props => {
            if (props.match.params.districtId) {
                return <RedirectToShortCodeUrl districtId={props.match.params.districtId} />;
            }
            const querystring = querystringify.parse(props.location.search);
            const nextUrl = querystring.next || '/';
            return <RedirectToLogin nextUrl={nextUrl} />;
        }}
    />
);

const logoutCallbackRoute = (
    <Route path="/logout-callback" exact key="logout-callback" component={CustomLogoutCallback} />
);

export { loginCallbackRoute, logoutCallbackRoute, loginRoute };
